import { render, staticRenderFns } from "./BoxFuneraria.vue?vue&type=template&id=669f1e8b&"
import script from "./BoxFuneraria.vue?vue&type=script&lang=js&"
export * from "./BoxFuneraria.vue?vue&type=script&lang=js&"
import style0 from "./BoxFuneraria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports